import { ColorGray800, ColorTextDefault } from "@nxt-costco-com/forge-design-tokens";
const COMPONENT_NAME = "TieredOfferCard";
const DEFAULT_LEFT_TILE_BACKGROUND_COLOR = ColorGray800;
const DEFAULT_RIGHT_TILE_CONTENT_ALIGNMENT = "center";
const DEFAULT_RIGHT_TILE_BACKGROUND_COLOR = ColorGray800;
const DEFAULT_MARKDOWN_TEXT_COLOR = ColorTextDefault;
export {
  COMPONENT_NAME,
  DEFAULT_LEFT_TILE_BACKGROUND_COLOR,
  DEFAULT_MARKDOWN_TEXT_COLOR,
  DEFAULT_RIGHT_TILE_BACKGROUND_COLOR,
  DEFAULT_RIGHT_TILE_CONTENT_ALIGNMENT
};
